<template>
  <b-modal
    id="show-site-plan-modal"
    size="xl"
    :title="title"
    hide-footer
    body-class="p-0"
    content-class="overflow-hidden"
  >
    <div class="text-center">
      <b-img fluid-grow :src="imageUrl" />
    </div>
  </b-modal>
</template>

<script>
  export default {
    props: {
      title: String,
      imageUrl: String,
    },
    data() {
      return {
        trans: trans,
      }
    },
  }
</script>
